import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@knockrentals/knock-react';
import { Formik } from 'formik';
import '../../_attributeInfo.scss';

class ChangeAttributeModal extends Component {
  state = {
    suggestions: Object.keys(this.props.suggestions).sort(),
  };

  render() {
    return (
      <Modal className="attribute-modal">
        <Formik
          initialValues={{
            attributeValue: this.props.sourceAttribute?.attribute || '',
            isUseNullAttribute: this.props.sourceAttribute.attribute === null,
          }}
          validate={this.validate}
          onSubmit={this.onConfirm.bind(this)}
        >
          {(props) => (
            <form onSubmit={props.handleSubmit} autoComplete="off">
              <ModalHeader>
                <h2>Modify Source Attribute</h2>
              </ModalHeader>
              <ModalContent>
                <div className="knock-react-flex">
                  <div className="field-label">Source</div>
                  <div className="field-input">
                    <i className="fa fa-building" />{' '}
                    {this.props.marketingSource.name}
                  </div>
                </div>
                <div className="knock-react-flex">
                  <div className="field-label">Default Attribute</div>
                  <div className="field-input">
                    {this.props.marketingSource.default_attribute ? (
                      <span>
                        <i className="fa fa-tags" />{' '}
                        {this.props.marketingSource.default_attribute}
                      </span>
                    ) : (
                      <span>
                        <i className="fa fa-tag" /> <em>None</em>
                      </span>
                    )}
                  </div>
                </div>
                <div className="knock-react-flex">
                  <div className="field-label">Effective Attribute</div>
                  <div className="field-input">
                    <input
                      className="knock-react-input"
                      disabled={props.values.isUseNullAttribute}
                      name="attributeValue"
                      onChange={props.handleChange}
                      placeholder="Custom source attribute"
                      type="text"
                      value={props.values.attributeValue}
                    />
                    {props.errors.attributeValue && (
                      <span className="knock-react-form-hint knock-react-form-hint-error">
                        {props.errors.attributeValue}
                      </span>
                    )}
                    <input
                      checked={props.values.isUseNullAttribute}
                      name="isUseNullAttribute"
                      onChange={props.handleChange}
                      onClick={this.handleNullAttributeToggle.bind(this, props)}
                      type="checkbox"
                      value={props.values.isUseNullAttribute}
                    />
                    No source attribute
                  </div>
                </div>

                <div className="knock-react-flex">
                  <div className="field-label">Suggestions</div>
                  <div className="field-input field-wrap">
                    {this.state.suggestions.length ? (
                      this.state.suggestions.map((suggestion, i) => {
                        return (
                          <a
                            key={`suggestion-${i}`}
                            className="mRight10"
                            onClick={this.loadSuggestion.bind(
                              this,
                              suggestion,
                              props
                            )}
                            href="#"
                          >
                            {suggestion}
                          </a>
                        );
                      })
                    ) : (
                      <em>None</em>
                    )}
                  </div>
                </div>
              </ModalContent>
              <ModalFooter>
                <button
                  className="btn-md btn-primary"
                  onClick={this.onCancel.bind(this)}
                  type="button"
                >
                  <i className="fa fa-lg fa-times-circle" /> Cancel
                </button>
                <button
                  className="btn-md btn-danger"
                  onClick={this.onRevertToDefault.bind(this)}
                  type="button"
                >
                  <i className="fa fa-lg fa-undo" /> Revert to Default
                </button>
                <button
                  className={`btn-md ${props.dirty ? 'btn-success' : ''}`}
                  disabled={!props.dirty}
                  type="submit"
                >
                  <i className="fa fa-lg fa-check-circle" /> Update Custom
                  Attribute
                </button>
              </ModalFooter>
            </form>
          )}
        </Formik>
      </Modal>
    );
  }

  handleNullAttributeToggle(formProps) {
    const {
      values: { isUseNullAttribute },
    } = formProps;

    if (!isUseNullAttribute) {
      formProps.setFieldValue('attributeValue', '');
    }
  }

  loadSuggestion(suggestion, formProps) {
    if (!formProps.values.isUseNullAttribute) {
      formProps.setFieldValue('attributeValue', suggestion);
    }
  }

  onConfirm(values) {
    const attributeValue = values.isUseNullAttribute
      ? null
      : values.attributeValue;

    this.props.updateAttribute(
      this.props.sourceAttribute.id,
      this.props.marketingSource.id,
      attributeValue
    );
  }

  onRevertToDefault() {
    this.props.deleteAttribute(this.props.sourceAttribute.id);
  }

  onCancel() {
    this.props.toggleModal(false);
  }

  validate(values) {
    const errors = {};
    const isInputRequired =
      !values.isUseNullAttribute && !values.attributeValue.trim();

    if (isInputRequired) {
      errors.attributeValue = 'Required';
    }

    return errors;
  }

  handleNullChange(formProps) {
    const {
      values: { isUseNullAttribute },
    } = formProps;

    formProps.setFieldValue('isUseNullAttribute', !isUseNullAttribute);
    formProps.setFieldValue('attributeValue', '');
  }
}

ChangeAttributeModal.propTypes = {
  deleteAttribute: PropTypes.func,
  marketingSource: PropTypes.object,
  sourceAttribute: PropTypes.object,
  suggestions: PropTypes.object,
  toggleModal: PropTypes.func,
  updateAttribute: PropTypes.func,
};

export default ChangeAttributeModal;
